/**
 * Module-scoped handoff for toasts that should fire after navigation back to pantry.
 * Allows recognition-results.tsx to set a pending toast message that PantryMobile
 * consumes when the user returns (via useFocusEffect or screen focus listener).
 */

let pending: string | null = null;

export const setPendingPantryToast = (msg: string) => {
  pending = msg;
};

export const consumePendingPantryToast = (): string | null => {
  const msg = pending;
  pending = null;
  return msg;
};
